import { Component } from '@angular/core';

@Component({
  selector: 'vota-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent {}
